// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__glrHw","validationTips":"StatementDescriptor_validationTips__3CP9w"};